import LinkButton from '@sats-group/ui-lib/react/link-button';
import Text from '@sats-group/ui-lib/react/text';
import cn from 'classnames';
import React from 'react';
import type { BootCampComponentList as Props } from './boot-camp-component-list.types';

/** This is named _Component List_ in Figma, but there's already a shared component with that name.
 *
 *  https://www.figma.com/design/gdal30EBz5labeopZZ3MYq/%F0%9F%8F%8B%EF%B8%8F-Boot-Camp?node-id=2362-93650
 */
const BootCampComponentList = <T extends { tall?: boolean }>({
  actions,
  description,
  entryRenderer,
  entries,
  title,
  columnCount = 3,
}: Props<T> & { entryRenderer: React.FC<T> }) => {
  const EntryRenderer = entryRenderer;
  const columns = entries.length === 2 ? 2 : columnCount;

  return (
    <div className="boot-camp-component-list">
      {description || title ? (
        <div className="boot-camp-component-list__texts">
          {title ? (
            <Text
              elementName="h2"
              size={Text.sizes.headline2}
              theme={Text.themes.emphasis}
              tight
            >
              {title}
            </Text>
          ) : null}
          {description ? (
            <Text elementName="p" size={Text.sizes.basic} tight>
              {description}
            </Text>
          ) : null}
        </div>
      ) : null}
      <div
        className={cn(
          'boot-camp-component-list__entries',
          `boot-camp-component-list__entries--${columns}-columns`
        )}
      >
        {entries.map(item => (
          <div className="boot-camp-component-list__entry" key={item.key}>
            <EntryRenderer {...item.props} tall />
          </div>
        ))}
      </div>
      {actions.length ? (
        <div className="boot-camp-component-list__actions">
          {actions.map(action => (
            <div key={action.href}>
              <LinkButton {...action} />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default BootCampComponentList;
